import React, { memo } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

const StyledDialogHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
}));

interface StackModalHeaderProps {
  title: string;
  onClose: () => void;
}

const StackModalHeader: React.FC<StackModalHeaderProps> = ({
  title,
  onClose,
}) => {
  return (
    <StyledDialogHeader>
      <Typography
        variant='h6'
        sx={{ textTransform: 'uppercase', fontWeight: 'bold' }}
      >
        {title}
      </Typography>
      <IconButton onClick={onClose} sx={{ mr: -2, mt: -1 }}>
        <CloseIcon />
      </IconButton>
    </StyledDialogHeader>
  );
};

export default memo(StackModalHeader);
